


















































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "../../lib/util";
import AbpBase from "../../lib/abpbase";
import Closure from "../../store/entities/booking/closure";
import IntTimePicker from '../../components/int-time-picker.vue';
import Ajax from '../../lib/ajax';
import DateCheckbox from '../../components/date-checkbox.vue';


@Component({
    components: { IntTimePicker,DateCheckbox }
})
export default class CreateClosure extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;

    @Prop({type: Number,default: 0}) courtId: number;

    closure: Closure = new Closure();

    // 保存订单
    save() {
        this.closure.courtId = this.courtId;
        (this.$refs.closureForm as any).validate(async (valid: boolean) => {
            if (valid) {
                await this.$store.dispatch({
                    type: "closure/create",
                    data: this.closure
                });
                (this.$refs.closureForm as any).resetFields();

                this.$Message.success(this.L('AddSuccessMessage',undefined,this.L('ClosureInfo')));
                
                this.$emit("input", false);
            }
        });
    }
    cancel() {
        (this.$refs.closureForm as any).resetFields();

        this.$emit("input", false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit("input", value);
        } else {
            this.closure.endTime = 1439;
            this.closure.startTime = 0;
        }
    }
    async created(){
        
    }
    mounted() {
        
    }
    closureRule = {
        startDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("StartDate")),
                trigger: "change"
            }
        ],
        endDate: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, this.L("EndDate")),
                trigger: "change"
            }
        ],
        dateType: [
            {
                required: true,
                type:"string",
                message: this.L("SelectIsRequired", undefined, '日期类型'),
                trigger: "change"
            }
        ]
    };
}
